import React, { useEffect, useState } from "react";
import "../index.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, useNavigate } from "react-router-dom";
import "./AdminDashboard.css";
import './OuraNav.css';
import fetchBase from "../utils/fetchBase";


import PayrollUpload from "./PayrollUpload";

const AdminDashboard = () => {

    const isDemo = localStorage.getItem("isDemo") === "true";

    const [menuOpen, setMenuOpen] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        AOS.init();
    }, []);
    const orgName = localStorage.getItem("admin_org") || "Admin";

    const handlePayrollClick = async () => {
        try {

            // ALWAYS check disk first — metadata is ignored
            const diskCheck = await fetch(`${fetchBase}/api/payroll/check-file`, {
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("jwt_token")
                }
            });

            if (diskCheck.status === 200) {
                // Live sheet exists → open Payroll Manager
                return navigate("/admin/payroll?tab=live");
            } else {
                // File missing → force upload
                return navigate("/payroll/upload");
            }


        } catch (err) {
            console.error("❌ Error checking payroll:", err);
            return navigate("/payroll/upload");
        }
    };
    return (
        <>
        {isDemo && (
            <div style={{
                background: "#0f62fe",
                color: "white",
                padding: "12px 20px",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "500",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                zIndex: 9999
            }}>
                Demo Mode — Explore the platform. No data will be saved.
            </div>
        )}
            {/* Top Nav Bar */}
            <nav className="apple-global-nav" style={{ marginTop: isDemo ? "44px" : "0" }}>

                {/* LEFT — Logo */}
                <div className="left-nav">
                    <img src="/images/logoPlaceholder1.png" alt="Logo" className="apple-logo"/>
                </div>

                {/* CENTER — Main Navigation */}
                <div className="center-nav">
                    <a href="#admin">Dashboard</a>
                    <a href="#employees">Calendar</a>
                    <a href="#clients">Clients</a>
                    <a
                        href="#" onClick={(e) => { e.preventDefault(); navigate("/employee-history"); }} > History </a>

                    <a
                        href="#payroll"
                        onClick={(e) => {
                            e.preventDefault();
                            handlePayrollClick();
                        }}
                    >
                        Payroll
                    </a>
                </div>
                <div className="account-dropdown-container">
                <span className="account-link">Account ▾</span>
                    <div className="account-dropdown">
                        <Link to="/account/profile">Profile</Link>
                        <Link to="/account/security">Security</Link>
                        <Link to="/notifications">Notifications</Link>
                        <Link to="/activity">Activity</Link>
                        <Link to="/applications">Applications</Link>
                        <Link to="/document-hub">Document Hub</Link>
                        <Link to="/logout">Log Out</Link>

                    </div>
                </div>

                {/* HAMBURGER BUTTON — MUST COME BEFORE RIGHT-NAV */}
                <button
                    className={`hamburger-btn ${menuOpen ? "open" : ""}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span className="bar"></span>
                    <span className="bar"></span>
                </button>

                {/* RIGHT — Account Dropdown */}
                <div className="right-nav">
                    <div className="account-dropdown">
                        <button className="account-btn">
                            Account ▾
                        </button>
                        <div className="dropdown-menu">
                            RIGHT NAV TEST
                            <Link to="/account/profile">Profile</Link>
                            <Link to="/logout">Log Out</Link>
                        </div>
                    </div>
                </div>

            </nav>


            {/* Fullscreen mobile Menu */}

            {menuOpen && (
                <div className="admin-mobile-menu">
                    <a href="#admin" onClick={() => setMenuOpen(false)}>Dashboard</a>
                    <a href="#employees" onClick={() => setMenuOpen(false)}>Employees</a>
                    <a href="#clients" onClick={() => setMenuOpen(false)}>Clients</a>
                    <Link to="/employee-history" onClick={() => setMenuOpen(false)}>History</Link>
                    <button
                        onClick={() => {
                            setMenuOpen(false);
                            handlePayrollClick();
                        }}
                        className="menu-btn-link"
                    >
                        Payroll
                    </button>
                    <Link to="/account/profile" onClick={() => setMenuOpen(false)}>Account</Link>
                    <Link to="/logout" onClick={() => setMenuOpen(false)}>Log Out</Link>
                </div>
            )}


            {/* Scrolling Content Sections */}
            <div id="fullpage">
                <div
                    id="admin"
                    style={{backgroundImage: "url('/images/background1.jpg')"}}
                    className="model3-container"
                >
                    <div className="header-container">
                        <h1 className="header" data-aos="fade-up" data-aos-duration="1000">
                            Welcome, {orgName}
                        </h1>
                        <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
                            Employees
                        </p>
                        <div
                            className="buttons"
                            data-aos="fade-up"
                            data-aos-delay="200"
                            data-aos-duration="1000"
                        >
                            <Link to="/employee-map" className="btn1">
                                ADD EMPLOYEE
                            </Link>


                            <Link to="/employees" className="btn2">
                                My Employees
                            </Link>
                            {/* must link to="/url" exactly as routed in app.js */}
                        </div>
                    </div>
                </div>

                <div
                    id="employees"
                    style={{backgroundImage: "url('/images/Calendar.png')"}}
                    className="model3-container"
                >
                    <div className="header-container">
                        <h1 className="header" data-aos="fade-up" data-aos-duration="1000">
                            Calendar
                        </h1>
                        <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">

                        </p>
                        <div
                            className="buttons"
                            data-aos="fade-up"
                            data-aos-delay="200"
                            data-aos-duration="1000"
                        >
                            <Link to="/scheduler" className="btnschedule">
                                Schedule
                            </Link>
                            <Link to="/employee-history" className="btnhistory">
                                History
                            </Link>
                        </div>
                    </div>
                </div>

                <div
                    id="clients"
                    style={{backgroundImage: "url('/images/Clients.png')"}}
                    className="model3-container"
                >
                    <div className="header-container">
                        <h1 className="header" data-aos="fade-up" data-aos-duration="1000">
                            Clients
                        </h1>
                        <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
                            Manage client profiles, scheduling addresses, and care history.
                        </p>
                        <div
                            className="buttons"
                            data-aos="fade-up"
                            data-aos-delay="200"
                            data-aos-duration="1000"
                        >
                            <Link to="/addclient" className="btn1">
                                Add
                            </Link>
                            <Link to="/admin/clients" className="btn2">
                                View Clients
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminDashboard;
